import * as React from "react";
import { format } from "date-fns";
import { IPageProps } from "../interfaces/page-props";
import { RouteComponentProps } from "react-router-dom";
import MuiTableWrapper from "../components/MuiComponents/MuiTableWrapper";
import PageHead from "../components/PageHead";
import { Button, Grid } from "@material-ui/core";
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { Form,Field } from "react-final-form";
import { FormApi, SubmissionErrors } from "final-form";
import DateFnsUtils from "@date-io/date-fns";
interface RouteParams {}
interface AuditItem {
  datetime:string
  event:string
  user:string
  ip:string
  data:string
}

const QuotationToolPage: React.FC<
  RouteComponentProps<RouteParams> & IPageProps
> = () => {

  return (<div className="content">
        <PageHead
          resellerID=""
          title="Quotation Tool"
          parents={[]}
          subpages={[]}
        >
        </PageHead>
        <iframe src="/voip/pricingcalculator.html" style={{width:'100%',borderStyle:'none',height: '3000px', overflow: 'hidden'}} />
      </div>)
}
export default QuotationToolPage;